import { gql } from '@apollo/client'
import { DISPLAY_FRAGMENT } from '../fragments/DisplayFragment'

export const GET_STORE_DISPLAYS = gql`
  query GetStoreDisplays($input: StoreDisplaysInput!) {
    storeDisplays(input: $input) {
      ...Display
    }
  }
  ${DISPLAY_FRAGMENT}
`
